/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




/* ============= Tab =============  */
document.addEventListener('DOMContentLoaded', function(){	
	const tabs = document.getElementsByClassName('tab');
	for(let i = 0; i < tabs.length; i++) {
		tabs[i].addEventListener('click', tabSwitch);
	}
	function tabSwitch(){	
		const ancestorEle = this.closest('.tab-panel');		
		ancestorEle.getElementsByClassName('is-active')[0].classList.remove('is-active');
		this.classList.add('is-active');		
		ancestorEle.getElementsByClassName('is-show')[0].classList.remove('is-show');
		const groupTabs = ancestorEle.getElementsByClassName('tab');
		const arrayTabs = Array.prototype.slice.call(groupTabs);
		const index = arrayTabs.indexOf(this);
		ancestorEle.getElementsByClassName('panel')[index].classList.add('is-show');
	};
});


/* ============= Pagetop Button =============  */
const pagetop_btn = document.querySelector(".pagetop-button");
pagetop_btn.addEventListener("click", scroll_top);
function scroll_top() {
  window.scroll({ top: 0, behavior: "smooth" });
}
// 【BON】透明のときはタップを素通りさせる（下の商品・バナーのタップを奪っていた）。表示中は0.2→0.6ではっきり見せる（2026-10-28）
window.addEventListener("scroll", scroll_event);
function scroll_event() {
  if (window.pageYOffset > 100) {
    pagetop_btn.style.opacity = "0.6";
    pagetop_btn.style.pointerEvents = "auto";
  } else {
    pagetop_btn.style.opacity = "0";
    pagetop_btn.style.pointerEvents = "none";
  }
}
scroll_event();

                    
/* ============= MobileMenuCategory =============  */
const menu = document.querySelectorAll(".mobile-menu__nav .category-item-collapsible");
function toggle() {
	const content = this.nextElementSibling;
	this.classList.toggle("is-active");
	content.classList.toggle("is-open");
}
for (let i = 0; i < menu.length; i++) {
	menu[i].addEventListener("click", toggle);
}


  
/* ===【UIUX改善】存在しない組み合わせに no_sku クラスを付与 === */
(function() {
  function getVariants() {
    var el = document.querySelector('[data-nosku-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  function updateNoSku(form, variants) {
    var selectedOptions = {};
    form.querySelectorAll('.product-form__single-selector[type="radio"]:checked').forEach(function(radio) {
      var pos = radio.dataset.optionPosition;
      if (pos) selectedOptions[pos] = radio.value;
    });

    form.querySelectorAll('.product-form__option').forEach(function(group, groupIndex) {
      var position = String(groupIndex + 1);
      if (position === '1') return;

      var priorSelected = {};
      for (var p in selectedOptions) {
        if (parseInt(p) < parseInt(position)) priorSelected[p] = selectedOptions[p];
      }
      if (Object.keys(priorSelected).length === 0) return;

      group.querySelectorAll('.color-swatch, .block-swatch, .variant-swatch').forEach(function(swatch) {
        var radio = swatch.querySelector('.product-form__single-selector');
        if (!radio) return;

        var exists = variants.some(function(v) {
          for (var p in priorSelected) {
            if (v['option' + p] !== priorSelected[p]) return false;
          }
          return v['option' + position] === radio.value;
        });

        exists ? swatch.classList.remove('no_sku') : swatch.classList.add('no_sku');
      });
    });
  }

  function init() {
    var variants = getVariants();
    if (!variants) return;

    document.querySelectorAll('.product-form__variants').forEach(function(form) {
      updateNoSku(form, variants);
      form.querySelectorAll('.product-form__single-selector').forEach(function(radio) {
        radio.addEventListener('change', function() {
          updateNoSku(form, variants);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===【UIUX改善】スティッキーフォーム：存在しない組み合わせに no_sku クラスを付与 === */
(function() {
  function getVariants() {
    var el = document.querySelector('[data-nosku-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  function updateNoSkuSticky(variants) {
    var stickyForm = document.querySelector('.ProductFormSticky__Form');
    if (!stickyForm) return;

    // 選択済みオプションを収集
    var selectedOptions = {};
    stickyForm.querySelectorAll('.Item__Input[type="radio"]:checked').forEach(function(radio) {
      var pos = radio.dataset.optionPosition;
      if (pos) selectedOptions[pos] = radio.value;
    });

    stickyForm.querySelectorAll('.FormOption').forEach(function(group) {
      var position = String(group.dataset.selectorPosition);
      if (position === '1') return;

      // この軸より前の選択済み軸を収集
      var priorSelected = {};
      for (var p in selectedOptions) {
        if (parseInt(p) < parseInt(position)) priorSelected[p] = selectedOptions[p];
      }
      if (Object.keys(priorSelected).length === 0) return;

      group.querySelectorAll('.color-swatch, .block-swatch, .variant-swatch').forEach(function(swatch) {
        var radio = swatch.querySelector('.Item__Input');
        if (!radio) return;

        var exists = variants.some(function(v) {
          for (var p in priorSelected) {
            if (v['option' + p] !== priorSelected[p]) return false;
          }
          return v['option' + position] === radio.value;
        });

        exists ? swatch.classList.remove('no_sku') : swatch.classList.add('no_sku');
      });
    });
  }

  function initSticky() {
    var variants = getVariants();
    if (!variants) return;

    // ページ読み込み時
    updateNoSkuSticky(variants);

    // 選択変更時
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('Item__Input')) {
        updateNoSkuSticky(variants);
      }
    });

    // スティッキーフォームが開かれた時にも実行
    var trigger = document.getElementById('form-drawer-triger');
    if (trigger) {
      trigger.addEventListener('click', function() {
        setTimeout(function() { updateNoSkuSticky(variants); }, 50);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky);
  } else {
    initSticky();
  }
})();

/* ===【UIUX改善】通常フォーム ↔ スティッキーフォーム 選択状態の連動 === */
(function() {
  function syncForms(sourceSelector, targetSelector, changedPosition, changedValue) {
    var targetForm = document.querySelector(targetSelector);
    if (!targetForm) return;

    // 対象フォーム内の同じ軸・同じ値のラジオボタンを探してチェック
    var targetRadios = targetForm.querySelectorAll(
      '[data-option-position="' + changedPosition + '"]'
    );
    targetRadios.forEach(function(radio) {
      if (radio.value === changedValue && !radio.checked) {
        radio.checked = true;
        // テーマJSに変更を通知（changeイベントを発火）
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function init() {
    // 通常フォーム → スティッキーフォームへ同期
    var normalForm = document.querySelector('.product-form__variants');
    if (normalForm) {
      normalForm.addEventListener('change', function(e) {
        if (!e.target.classList.contains('product-form__single-selector')) return;
        var pos = e.target.dataset.optionPosition;
        var val = e.target.value;
        if (pos && val) {
          syncForms('.product-form__variants', '.ProductFormSticky__Form', pos, val);
        }
      });
    }

    // スティッキーフォーム → 通常フォームへ同期
    var stickyForm = document.querySelector('.ProductFormSticky__Form');
    if (stickyForm) {
      stickyForm.addEventListener('change', function(e) {
        if (!e.target.classList.contains('Item__Input')) return;
        var pos = e.target.dataset.optionPosition;
        var val = e.target.value;
        if (pos && val) {
          syncForms('.ProductFormSticky__Form', '.product-form__variants', pos, val);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ===== ProductFormSticky 数量セレクター =====
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="decrease-sticky-quantity"], [data-action="increase-sticky-quantity"]');
  if (!btn) return;

  var drawer = btn.closest('.ProductFormSticky__Drawer');
  if (!drawer) return;

  var input = drawer.querySelector('input[name="quantity"]');
  if (!input) return;

  var current = parseInt(input.value, 10) || 1;
  if (btn.dataset.action === 'increase-sticky-quantity') {
    input.value = current + 1;
  } else if (btn.dataset.action === 'decrease-sticky-quantity') {
    input.value = Math.max(1, current - 1);
  }
  input.size = Math.max(2, String(input.value).length);
});



/* ******************************************** */
/* ===【UIUX改善】商品画像クリック → フルスクリーンモーダル（縦スクロール全画像表示） === */
(function () {
  function initProductImageModal() {
    var gallery = document.querySelector('.product-gallery__carousel');
    if (!gallery) return;

    if (!document.getElementById('product-image-fullscreen-modal')) {
      var modal = document.createElement('div');
      modal.id = 'product-image-fullscreen-modal';
      modal.innerHTML = [
        '<div id="product-image-fullscreen-overlay"></div>',
        '<div id="product-image-fullscreen-inner">',
        '  <button id="product-image-fullscreen-close" aria-label="閉じる">&#x2715;</button>',
        '  <div id="product-image-fullscreen-scroll"></div>',
        '</div>'
      ].join('');
      document.body.appendChild(modal);
    }

    var modal    = document.getElementById('product-image-fullscreen-modal');
    var btnClose = document.getElementById('product-image-fullscreen-close');
    var scrollEl = document.getElementById('product-image-fullscreen-scroll');

    function buildImageList() {
      var images = [];
      gallery.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered) .product-gallery__image').forEach(function (el) {
        var src = el.dataset.zoom || el.dataset.src || el.src || '';
        if (!src && el.dataset.srcset) {
          var parts = el.dataset.srcset.split(',');
          src = parts[parts.length - 1].trim().split(' ')[0];
        }
        var alt = el.alt || '';
        if (src) images.push({ src: src, alt: alt });
      });
      return images;
    }

    function openModal(startIndex) {
      var images = buildImageList();
      if (!images.length) return;

      scrollEl.innerHTML = '';

      var imgEls = images.map(function (item, i) {
        var wrapper = document.createElement('div');
        wrapper.className = 'product-image-fullscreen-item';
        wrapper.dataset.index = i;

        var img = document.createElement('img');
        img.alt = item.alt;
        img.className = 'product-image-fullscreen-img';
        img._targetSrc = item.src;

        wrapper.appendChild(img);
        scrollEl.appendChild(wrapper);
        return img;
      });

      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      var loaded = 0;
      var total = imgEls.length;

      function tryScroll() {
        loaded++;
        if (loaded >= total) {
          scrollToIndex(startIndex);
        }
      }

      imgEls.forEach(function (img) {
        img.addEventListener('load', tryScroll, { once: true });
        img.addEventListener('error', tryScroll, { once: true });
        img.src = img._targetSrc;
      });
    }

    function scrollToIndex(index) {
      var target = scrollEl.querySelector('[data-index="' + index + '"]');
      if (target) {
        scrollEl.scrollTop = target.offsetTop - 60;
      }
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      scrollEl.innerHTML = '';
    }

    // ▼ スワイプ判定用変数
    var touchStartX = 0;
    var touchStartY = 0;
    var touchMoved  = false;
    var SWIPE_THRESHOLD = 8; // px：これ以上横移動したらスワイプとみなす

    gallery.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchMoved  = false;
    }, { passive: true });

    gallery.addEventListener('touchmove', function (e) {
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      // 横移動が縦移動より大きく、かつ閾値を超えたらスワイプ
      if (dx > SWIPE_THRESHOLD && dx > dy) {
        touchMoved = true;
      }
    }, { passive: true });

    // ▼ .product-gallery__size-limiter クリック／タップでモーダルを開く
    gallery.addEventListener('click', function (e) {
      // スワイプ後のタップは無視
      if (touchMoved) {
        touchMoved = false;
        return;
      }
      var sizeLimiter = e.target.closest('.product-gallery__size-limiter');
      if (!sizeLimiter) return;
      var item = sizeLimiter.closest('.product-gallery__carousel-item');
      if (!item) return;
      if (item.dataset.mediaType && item.dataset.mediaType !== 'image') return;
      var items = Array.from(gallery.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)'));
      var idx = items.indexOf(item);
      openModal(idx >= 0 ? idx : 0);
    });

    // ▼ scrollEl クリック：画像以外（余白）をクリックしたら閉じる
    scrollEl.addEventListener('click', function (e) {
      if (!e.target.closest('.product-image-fullscreen-img')) {
        closeModal();
      }
    });

    btnClose.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductImageModal);
  } else {
    initProductImageModal();
  }
})();

/*
// 【UIUX改善】スマホ表示時の検索ボックスをスクロールすると隠し、検索アイコンをクリックで検索画面に
(function () {
  var mq = window.matchMedia('(max-width: 640px)'); // 実際のSPブレークポイントに合わせて要調整
  if (!mq.matches) return;

  var searchHeader = document.querySelector('.header.header--inline');
  var searchWrapper = document.querySelector('.header__search-bar-wrapper');
  var searchIconItem = document.querySelector('.header__action-item.hidden-tablet-and-up');
  if (!searchHeader || !searchWrapper || !searchIconItem) return;

  var SCROLL_THRESHOLD = 40;
  var scrolled = false;

  // 要件1: ページアクセス時は検索ボックス表示・アイコン非表示
  searchHeader.classList.add('header--search-expanded');
  searchWrapper.classList.add('is-visible');
  searchIconItem.classList.add('js-hidden');

  function handleScroll() {
    if (window.scrollY > SCROLL_THRESHOLD) {
      if (!scrolled) {
        // 要件2: スクロールしたら検索ボックス→検索アイコンに切り替え
        searchHeader.classList.remove('header--search-expanded');
        searchWrapper.classList.remove('is-visible');
        searchIconItem.classList.remove('js-hidden');
        scrolled = true;
      }
    } else if (scrolled) {
      searchHeader.classList.add('header--search-expanded');
      searchWrapper.classList.add('is-visible');
      searchIconItem.classList.add('js-hidden');
      scrolled = false;
    }
  }
  window.addEventListener('scroll', handleScroll, { passive: true });

  // 要件3: アイコンタップで、検索ボックスタップ時と同じ全画面表示にする
  searchIconItem.addEventListener('click', function (event) {
    if (!scrolled) return; // ボックス表示中は既存動作のまま
    event.preventDefault();
    event.stopPropagation();

    var input = searchWrapper.querySelector('[name="q"]');

    searchHeader.classList.add('header--search-expanded');
    searchWrapper.classList.add('is-visible', 'is-fixed');
    document.body.classList.add('no-mobile-scroll');

    if (input) {
      input.focus(); // 検索ボックスタップ時と同じ処理を発火させる
    }
  }, true);

  // 全画面検索を閉じたとき、スクロール済みならアイコン表示に戻す
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-action="unfix-search"]')) return;
    if (window.scrollY > SCROLL_THRESHOLD) {
      searchHeader.classList.remove('header--search-expanded');
      searchWrapper.classList.remove('is-visible');
      searchIconItem.classList.remove('js-hidden');
    }
  });
})();
*/


////////////////////////////////////////////////////////////////////////////////////
// ジャッジミー表示項目をカスタマイズ
////////////////////////////////////////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", function() {
    // DOMの変更を監視するオブザーバーを作成
    const observer = new MutationObserver(function(mutations) {
        
        // ---------------------------------------------------
        // 1. 投稿者名を「ご購入者様」に変更する処理
        // ---------------------------------------------------
        const authorElements = document.querySelectorAll('.jm-reviewer-info__name');
        authorElements.forEach(function(el) {
            if (el.textContent.trim() === '匿名') {
                el.textContent = 'ご購入者様';
                
                if (el.getAttribute('title') === '匿名') {
                    el.setAttribute('title', 'ご購入者様');
                }
            }
        });

        // ---------------------------------------------------
        // 2. 日付フォーマットを「YYYY/MM/DD」に変更する処理
        // ---------------------------------------------------
        // jm-text クラスを持つ要素をすべて取得
        const textElements = document.querySelectorAll('.jm-text');
        
        // 「MM/DD/YYYY」のパターンを見つけるための正規表現（例: 05/23/2026）
        const dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
        
        textElements.forEach(function(el) {
            const text = el.textContent.trim();
            const match = text.match(dateRegex);
            
            // もしテキストが「MM/DD/YYYY」の形に完全一致したら
            if (match) {
                // match[1] = 月(05)
                // match[2] = 日(23)
                // match[3] = 年(2026)
                // この順番を「年/月/日」に並び替えて書き換える
                el.textContent = `${match[3]}/${match[1]}/${match[2]}`;
            }
        });

    });

    // body全体を監視対象とする（非同期での読み込みに対応するため）
    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    
    // 監視を開始
    observer.observe(targetNode, config);
});


// 動画全画面になってもミュート状態を維持
document.addEventListener('DOMContentLoaded', () => {
  // クラス名「mp4_area」を持つ動画要素をすべて取得
  const videos = document.querySelectorAll('video.mp4_area');

  videos.forEach((video) => {
    // 標準のフルスクリーン変更イベント
    document.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement === video) {
        video.muted = true;
      }
    });

    // iOS Safari等の古いWebkit環境用イベント
    document.addEventListener('webkitfullscreenchange', () => {
      if (document.webkitFullscreenElement === video) {
        video.muted = true;
      }
    });
  });
});



////////////////////////////////////////////////////////////////////////////
// お問い合わせフォーム（商品ページ⇒商品番号を自動入力）
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// お問い合わせフォーム（商品ページ⇒商品番号を自動入力）
////////////////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function () {
  var contactLink = document.querySelector('.product-contact-link');
  var skuEl = document.querySelector('.product-meta__sku-number');
  if (!contactLink || !skuEl) return;

  // クリックした「その瞬間」の商品番号を読み取ってからリンク先へ遷移する。
  // href を DOMContentLoaded 時に一度だけ設定すると、その後ユーザーが
  // バリエーション（SKU）を選び直しても反映されないため、
  // クリック時に毎回 href を組み立て直す。
  contactLink.addEventListener('click', function (e) {
    var sku = skuEl.textContent.trim();
    var url = new URL(contactLink.href, window.location.origin);
    url.searchParams.set('product', sku);

    // 動的に書き換えた href へ改めて遷移させる
    e.preventDefault();
    window.location.href = url.toString();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var params = new URLSearchParams(window.location.search);
  var product = params.get('product');
  if (product) {
    var input = document.getElementById('contact-form-商品番号');
    if (input) input.value = decodeURIComponent(product);
  }
});

////////////////////////////////////////////////////////////////////////////

// custom.js に追加
function updatePutuputuAnchorOffset() {
  var offset = window.matchMedia('(min-width: 768px)').matches ? 158 : 125;
  document.querySelectorAll('a[href^="#putuputu_"]').forEach(function (a) {
    a.setAttribute('data-offset', offset);
  });
}
updatePutuputuAnchorOffset();
window.addEventListener('resize', updatePutuputuAnchorOffset);
document.addEventListener('shopify:section:load', updatePutuputuAnchorOffset);